<template>
  <div>
    <vue-good-table
      mode="remote"
      :columns="columns"
      :rows="rows"
      :totalRows="totalRecords"
      :isLoading.sync="isLoading"
      styleClass="vgt-table bordered"
      :sort-options="{
          enabled: false,
          initialSortBy: [{field: 'period', type: 'desc'}]
        }"
      :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span
          v-if="props.column.field == 'amount'"
          style="text-align: right;"
        >$ {{ props.formattedRow.amount | formatNumberCurrency }}</span>
        <span
          v-else-if="props.column.field == 'tatalMonth'"
          style="text-align: right;"
        >$ {{ props.formattedRow.tatalMonth | formatNumberCurrency }}</span>
        <span v-else-if="props.column.field == 'objective'">
          <div v-if="props.formattedRow.amount < props.formattedRow.tatalMonth">cumplida</div>
          <div v-else>No cumplida</div>
        </span>
      </template>
    </vue-good-table>
  </div>
</template>
<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'

export default {
  components: {
    VueGoodTable
  },
  data () {
    return {
      totalRecords: 0,
      isLoading: false,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Período',
          field: 'period',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Tipo de meta',
          field: 'type',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Meta del mes',
          field: 'amount',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Monto de operaciones',
          field: 'tatalMonth',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Meta',
          field: 'objective',
          filterOptions: {
            enabled: false
          }
        }
      ],
      rows: []
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getReportMetricsUtility', JSON.stringify({
          first: first,
          ...this.serverParams
        }))
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>
